import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class MeanOfIdService {

  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'MeansOfIdentification/';
  // fetch all MeansOfIdentification in the database
  allMeansOfId(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getMeansOfIdentification(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getMeansOfIdentificationByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postMeansOfIdentification(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteMeansOfIdentification(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateMeansOfIdentification(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
